import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getConsolidationManifestPdf = {
  name: "getConsolidationManifestPdf" as const,
  input: z.object({ consolidationId: consolidationIdFormat.schema }),
  output: z.object({ url: z.string() }),
};
